import Lottie from "react-lottie";
import animationData from "../../assets/loading.json";
type Size = "x-small" | "small" | "medium" | "large";

const XS_SIZE = 48;
const S_SIZE = 96;
const M_SIZE = 144;
const L_SIZE = 192;

interface Props {
  size?: Size | number;
}

export const LoadingSpinner = ({ size = "medium" }: Props) => {
  const s =
    typeof size === "string"
      ? size === "x-small"
        ? XS_SIZE
        : size === "small"
          ? S_SIZE
          : M_SIZE
      : size;

  if (typeof size === "string") {
    switch (size) {
      case "x-small":
        return (
          <Lottie
            options={{ animationData }}
            height={XS_SIZE}
            width={XS_SIZE}
            isClickToPauseDisabled={true}
          />
        );
      case "small":
        return (
          <Lottie
            options={{ animationData }}
            height={S_SIZE}
            width={S_SIZE}
            isClickToPauseDisabled={true}
          />
        );
      case "medium":
        return (
          <Lottie
            options={{ animationData }}
            height={M_SIZE}
            width={M_SIZE}
            isClickToPauseDisabled={true}
          />
        );

      case "large":
        return (
          <Lottie
            options={{ animationData }}
            height={L_SIZE}
            width={L_SIZE}
            isClickToPauseDisabled={true}
          />
        );
    }
  }

  return (
    <Lottie
      options={{ animationData }}
      height={s}
      width={s}
      isClickToPauseDisabled={true}
    />
  );
};
